/**
 * Created by Mark on 05/04/2017.
 */


import React from "react";
import PieGraph from './graphs/PieGraph.js';
import { FormattedMessage } from 'react-intl';

export default class HomeworkWidget extends React.Component {


    constructor(props){
        super();
        console.log(props.totalIncomplete || 0);
        this.state = {
            totalComplete : props.totalComplete || 0,
            totalIncomplete : props.totalIncomplete || 0,
            totalOverdue : props.totalOverdue || 0,
            studentTotal : props.studentTotal || 0,
        }
    }
    render(){
        return (
            <div>
                <div className="pie-grid clearfix text-center">
                    <div className="col-xs-4 col-sm-6 col-md-4 pg-item">
                        <PieGraph data={[{name: '' , value: Number(this.state.totalComplete) , fill:"#ffffff" }, {name: '' , value: Number(this.state.studentTotal) -  Number(this.state.totalComplete) , fill:"none"}]} index={0} id="HomeworkCompleted"  height={150} />
                        <div className="pgi-title">
                            {Number(this.state.totalComplete)} <FormattedMessage id={ 'ui-772' } defaultMessage={ 'Homework Completed' } />
                        </div>
                    </div>
                    <div className="col-xs-4 col-sm-6 col-md-4 pg-item">
                        <PieGraph data={[{name: '' , value: Number(this.state.totalIncomplete) , fill:"#ffffff" }, {name: '' , value: Number(this.state.studentTotal) -  Number(this.state.totalIncomplete) , fill:"none"}]} index={0} id="HomeworkNotCompleted" height={150}/>
                        <div className="pgi-title">
                            {Number(this.state.totalIncomplete)}  <FormattedMessage id={ 'ui-773' } defaultMessage={ 'Not Completed' } />
                        </div>
                    </div>
                    <div className="col-xs-4 col-sm-6 col-md-4 pg-item">
                        <PieGraph data={[{name: '' , value: Number(this.state.totalOverdue) , fill:"#ffffff" }, {name: '' , value: Number(this.state.studentTotal) -  Number(this.state.totalOverdue) , fill:"none"}]} index={0} id="HomeworkCompleted"  height={150} />
                        <div className="pgi-title">
                            {Number(this.state.totalOverdue)}  <FormattedMessage id={ 'ui-774' } defaultMessage={ 'Overdue' } />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/homework.js